var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("p", [
            _vm._v(
              "Thank you for ordering. You will receive an email that indicates your order has been placed. A second confirmation email will be sent once the order is awarded including the final fee and due date. If you require any changes/updates after you have placed your order, please respond to your confirmation email."
            )
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            [
              !_vm.isAdmin
                ? [
                    _c("div", { staticClass: "col-lg-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "order-type" } }, [
                            _vm._v("Please select an option.")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            class: { "is-invalid": _vm.errors.order_type },
                            attrs: {
                              id: "order-type",
                              options: this.orderTypes
                            },
                            model: {
                              value: _vm.form.order_type,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "order_type", $$v)
                              },
                              expression: "form.order_type"
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.order_type
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.errors.order_type) +
                                    "\n                            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "order-upgrade" } }, [
                          _vm._v("Is this an upgrade to an existing project?")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.upgrade_flag,
                                expression: "form.upgrade_flag"
                              }
                            ],
                            staticClass: "form-control",
                            class: { "is-invalid": _vm.errors.upgrade_flag },
                            attrs: { id: "order-upgrade" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.form,
                                  "upgrade_flag",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "Yes" } }, [
                              _vm._v(
                                "\n                                    Yes\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "No" } }, [
                              _vm._v(
                                "\n                                    No\n                                "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.errors.upgrade_flag
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.errors.upgrade_flag) +
                                  "\n                            "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Site")]),
                    _vm._v(" "),
                    _c("multiselect", {
                      class: { "is-invalid": _vm.errors.site },
                      attrs: {
                        id: "site",
                        "track-by": "id",
                        label: "value",
                        options: _vm.sites.items,
                        loading: _vm.sites.loading
                      },
                      model: {
                        value: _vm.form.site,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "site", $$v)
                        },
                        expression: "form.site"
                      }
                    }),
                    _vm._v(" "),
                    _c("small", { staticClass: "form-text text-muted" }, [
                      _vm._v(
                        "\n                            If you don't see your site listed and you have just created it, please wait a little longer and try your order again after a few minutes.\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.errors.site
                      ? _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.errors.site) +
                              "\n                        "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "file_number" } }, [
                    _vm._v("Client Loan/File No.")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.file_number,
                        expression: "form.file_number"
                      }
                    ],
                    ref: "file_number",
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.errors.file_number },
                    attrs: { type: "text", name: "file_number" },
                    domProps: { value: _vm.form.file_number },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "file_number", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors.file_number
                    ? _c(
                        "div",
                        {
                          staticClass: "invalid-feedback",
                          staticStyle: { display: "block" }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.errors.file_number) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-3" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "reference_number" } }, [
                    _vm._v("Former LCS Job Number")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.reference_number,
                        expression: "form.reference_number"
                      }
                    ],
                    ref: "reference_number",
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.errors.reference_number },
                    attrs: { type: "text", name: "reference_number" },
                    domProps: { value: _vm.form.reference_number },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.form,
                          "reference_number",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v(
                      "\n                            Only enter this if applicable.\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.errors.reference_number
                    ? _c(
                        "div",
                        {
                          staticClass: "invalid-feedback",
                          staticStyle: { display: "block" }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.errors.reference_number) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "site_contact_others" } }, [
                    _vm._v(
                      "\n                            Additional Contacts\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    attrs: {
                      id: "site_contact_others",
                      label: "name",
                      "track-by": "id",
                      options: this.contacts.items,
                      multiple: ""
                    },
                    model: {
                      value: _vm.form.site_contact_others,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "site_contact_others", $$v)
                      },
                      expression: "form.site_contact_others"
                    }
                  }),
                  _vm._v(" "),
                  _c("small", { staticClass: "form-text text-muted" }, [
                    _vm._v(
                      "\n                            If you wish to include any other contacts in communications about this order, please\n                            select them here.\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.errors.site_contact_others
                    ? _c("div", { staticClass: "invalid-feedback d-block" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.errors.site_contact_others) +
                            "\n                        "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "site_contact_name" } }, [
                  _vm._v("Property Site Contact Name")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.site_contact_name,
                      expression: "form.site_contact_name"
                    }
                  ],
                  ref: "site_contact_name",
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.site_contact_name },
                  attrs: { type: "text", name: "site_contact_name" },
                  domProps: { value: _vm.form.site_contact_name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.form,
                        "site_contact_name",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.site_contact_name
                  ? _c(
                      "div",
                      {
                        staticClass: "invalid-feedback",
                        staticStyle: { display: "block" }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.errors.site_contact_name) +
                            "\n                        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "site_contact_phone" } }, [
                    _vm._v("Property Site Contact Phone")
                  ]),
                  _vm._v(" "),
                  _c("phone-numbers", {
                    ref: "site_contact_phone",
                    attrs: { id: "site_contact_phone" },
                    model: {
                      value: _vm.form.site_contact_phone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "site_contact_phone", $$v)
                      },
                      expression: "form.site_contact_phone"
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors.site_contact_phone
                    ? _c(
                        "div",
                        {
                          staticClass: "invalid-feedback",
                          staticStyle: { display: "block" }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.errors.site_contact_phone) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "site_contact_email" } }, [
                    _vm._v("Property Site Contact Email")
                  ]),
                  _vm._v(" "),
                  _c("email-addresses", {
                    ref: "site_contact_email",
                    attrs: { id: "site_contact_email" },
                    model: {
                      value: _vm.form.site_contact_email,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "site_contact_email", $$v)
                      },
                      expression: "form.site_contact_email"
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors.site_contact_email
                    ? _c(
                        "div",
                        {
                          staticClass: "invalid-feedback",
                          staticStyle: { display: "block" }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.errors.site_contact_email) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.form.items.length === 0
            ? [_vm._m(0)]
            : _vm._l(_vm.form.items, function(item, idx) {
                return _c("product-form", {
                  key: idx,
                  attrs: {
                    detail: item,
                    company: _vm.company.item,
                    products: _vm.products.items,
                    appraisers: _vm.appraisers.items,
                    "is-admin": _vm.isAdmin,
                    errors: _vm.getItemError(idx)
                  },
                  on: { delete: _vm.onDelete }
                })
              }),
          _vm._v(" "),
          _vm.hasItemsError
            ? _c(
                "div",
                {
                  staticClass: "invalid-feedback",
                  staticStyle: { display: "block" }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getItemsError) +
                      "\n            "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.site
            ? _c("div", { staticClass: "row justify-content-center" }, [
                _vm.siteShareLink && !_vm.siteDisallowDownloads
                  ? _c("div", { staticClass: "col-md-6 mb-3" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-block btn-secondary",
                          on: {
                            click: function($event) {
                              return _vm.onOpen(_vm.siteShareLink)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        View Files\n                    "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.siteRequestLink && !_vm.siteDisallowUploads
                  ? _c("div", { staticClass: "col-md-6 mb-3" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-block btn-secondary",
                          on: {
                            click: function($event) {
                              return _vm.onOpen(_vm.siteRequestLink)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Upload Files\n                    "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(1)
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-footer" }, [
        _vm.loading
          ? _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c("i", { staticClass: "fas fa-2x fa-cog fa-spin" })
            ])
          : _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  on: {
                    click: function($event) {
                      return _vm.onAdd()
                    }
                  }
                },
                [_vm._v("\n                    Add Item\n                ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-primary", on: { click: _vm.onSubmit } },
                [
                  _c("i", { staticClass: "fas fa-save" }),
                  _vm._v(" Submit\n                ")
                ]
              )
            ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card lcs-product" }, [
      _c("div", { staticClass: "card-body text-center" }, [
        _vm._v(
          "\n                        No items available.\n                    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-light text-center mb-0",
        attrs: { role: "alert" }
      },
      [
        _vm._v(
          "\n                You will receive an initial email indicating your order has been placed and is pending. A second\n                email will be sent when the order is confirmed including the fee and due date. "
        ),
        _c("b", [
          _vm._v(
            "PLEASE NOTE: If you are uploading files, please remember to submit the order once you are done."
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }